<template>
  <div class="container personInfoForm">
    <left-aslide :activeNum="'2'"></left-aslide>
    <body-layout>
      <template slot="page-header">
        <filter-layout>
          <template slot="filter-left">
            <span>{{ title }}</span>
          </template>
          <template slot="filter-right" v-if="!isEdit">
            <el-button type="primary" @click="editInfo">编辑</el-button>
          </template>
        </filter-layout>
      </template>
      <template slot="ebs-content">
        <el-form
          :model="forms"
          label-width="180px"
          class="formPage el-viewform"
          ref="form"
        >
          <el-collapse v-model="activeName">
            <el-collapse-item title="企业基本信息" name="company">
              <el-form-item
                v-for="(item, index) in forms.company"
                :label="item.label"
                :key="index"
                :rules="!isEdit ? {} : item.rules"
                :prop="item.key"
              >
                <div v-if="!isEdit">
                  <span v-if="item.type === 'el-cascader'">{{
                    item.format
                  }}</span>
                  <template v-else-if="item.type === 'el-upload'">
                    <el-button
                      v-if="item.value"
                      type="text"
                      @click="handleDownload(item.value)"
                      >{{ item.format }} 下载</el-button
                    >
                  </template>
                  <span v-else-if="item.type === 'el-date-picker'">{{
                    item.value && dayjs(item.value).format('YYYY-MM-DD')
                  }}</span>
                  <span v-else-if="item.name === 'textarea'">
                    <el-popover
                      placement="top-start"
                      width="400"
                      trigger="hover"
                      :content="item.value"
                    >
                   
                      <el-button type="text" slot="reference"
                        >  {{ item.value?item.value.slice(0,10):'' }} <span v-if="item.value.length >10">.......<i class="el-icon-view el-icon--right"></i></span></el-button
                      >
                    </el-popover>
                  </span>
                  <span v-else class="info-text">
                    {{ item.value }}
                  </span>
                </div>
                <div
                  v-else
                  :style="{
                    width: item.type === 'el-upload' ? '200%' : 'auto',
                  }"
                >
                  <template v-if="item.type === 'el-select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.placeholder"
                    >
                      <el-option
                        v-for="data in item.options"
                        :key="data.value"
                        :label="data.label"
                        :value="data.value"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.type === 'el-cascader'">
                    <el-cascader
                      v-model="item.value"
                      :options="item.options"
                    ></el-cascader>
                  </template>
                  <template v-else-if="item.type === 'el-upload'">
                    <Upload
                      :uploadTitle="item.btnName"
                      :fileId="item.value"
                      @fileIdCb="(file) => uploadSuccess(file, item)"
                    >
                      <template #explain>
                        {{ item.tips }}
                      </template>
                    </Upload>
                  </template>
                  <template v-else-if="item.type === 'el-date-picker'">
                    <el-date-picker
                      v-model="item.value"
                      type="date"
                      :placeholder="item.placeholder"
                    >
                    </el-date-picker>
                  </template>
                  <template v-else>
                    <el-input
                      :type="item.name ? item.name : 'input'"
                      v-model="item.value"
                      :placeholder="item.placeholder"
                    ></el-input>
                  </template>
                </div>
              </el-form-item>
            </el-collapse-item>
            <el-collapse-item title="财务信息" name="finance">
              <el-form-item
                v-for="(item, index) in forms.finance"
                :label="item.label"
                :key="index"
                :rules="!isEdit ? {} : item.rules"
                :prop="item.key"
              >
                <div v-if="!isEdit">
                  <span v-if="item.type === 'el-radio'">{{
                    item.value ? (item.value === '1' ? '是' : '否') : ''
                  }}</span>
                  <span v-else-if="item.type === 'el-date-picker'">{{
                    item.value ? dayjs(item.value).format('YYYY-MM-DD') : ''
                  }}</span>
                  <span v-else class="info-text">{{ item.value }}</span>
                </div>
                <div v-else>
                  <template v-if="item.type === 'el-date-picker'">
                    <el-date-picker
                      v-model="item.value"
                      type="date"
                      :placeholder="item.placeholder"
                    >
                    </el-date-picker>
                  </template>
                  <template v-else-if="item.type === 'el-radio'">
                    <el-radio v-model="item.value" label="1">是</el-radio>
                    <el-radio v-model="item.value" label="0">否</el-radio>
                  </template>
                  <template v-else-if="item.type === 'el-select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.placeholder"
                    >
                      <el-option
                        v-for="data in item.options"
                        :key="data.value"
                        :label="data.label"
                        :value="data.value"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-else>
                    <el-input
                      :type="item.name ? item.name : 'input'"
                      v-model="item.value"
                      :placeholder="item.placeholder"
                    ></el-input>
                  </template>
                </div>
              </el-form-item>
            </el-collapse-item>
          </el-collapse>
          <div style="padding: 10px; text-align: center">
            <el-button type="primary" v-if="isEdit" @click="saveForm"
              >提交</el-button
            >
            <el-button
              type="primary"
              plain
              v-if="isEdit"
              @click="isEdit = false"
              >取消</el-button
            >
          </div>
        </el-form>
      </template>
    </body-layout>
  </div>
</template>

<script>
import { data } from '@/util/cityData'
import { cloneDeep, merge } from 'lodash'
import { getUserRes, updateUserRes } from '@/api/user'
import { queryByFileId } from '@/api/upload'
import { download } from '@/shared/file'
import Upload from '@/common/upload/uoload.vue'
import dayjs from 'dayjs'

const flat = (o) => {
  return o.reduce((per, cur) => {
    per[cur.key] = cur.value
    return per
  }, {})
}

const queryValue = (all, k) => all.find((a) => a.key === k).value
const queryLabel = (all, k) => all.find((a) => a.key === k).label
const queryKeyIndex = (all, k) => all.findIndex((a) => a.key === k)

const baseValid = function (k, valid, rule, _, cb) {
  const v = queryValue(this.forms[k], rule.field)
  const label = queryLabel(this.forms[k], rule.field)
  if (!v) {
    cb(new Error(`请输入${label}`))
  }
  valid(v, cb)
}

export default {
  name: 'personalInfo',
  components: {
    Upload,
  },
  data() {
    const validCode = (v, cb) => {
      const reg =
        /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
      if (!v) {
        return cb(new Error(''))
      }
      if (!reg.test(v)) {
        cb(new Error('请输入合法的统一社会代码'))
      } else {
        cb()
      }
    }
    const validName = (v, cb) => {
      if (!v) {
        cb(new Error('请输入企业名称'))
      }
      cb()
    }
    return {
      dayjs,
      isEdit: false,
      title: '我的资料',
      activeName: ['company', 'finance'],
      forms: {
        //码值待优化为枚举值，由于没有明确的码值定义，目前暂时用中文，等后期替换为码值(别想为什么 我也好奇为什么没有枚举值)
        company: [
          {
            label: '企业名称',
            key: 'companyName',
            value: '',
            // rules: [
            //   {
            //     required: true,
            //     validator: baseValid.bind(this, 'company', validName),
            //     trigger: 'blur',
            //   },
            // ],
            type: 'el-input',
            placeholder: '请输入企业名称',
          },
          {
            label: '统一社会信用代码',
            key: 'unifySocietyCreditCode',
            value: '',
            // rules: [
            //   {
            //     required: true,
            //     validator: baseValid.bind(this, 'company', validCode),
            //     trigger: 'blur',
            //   },
            // ],
            type: 'el-input',
            placeholder: '请输入统一社会信用代码',
          },
          {
            label: '法定代表人',
            key: 'legalPerson',
            value: '',
            type: 'el-input',
            placeholder: '请输入法定代表人',
          },
          {
            label: '法人代表证件类型',
            key: 'certificatesType',
            value: '',
            type: 'el-select',
            placeholder: '请选择法人代表证件类型',
            options: [
              {
                value: '居民身份证',
                label: '居民身份证',
              },
              {
                value: '军官证',
                label: '军官证',
              },
              {
                value: '武警警官证',
                label: '武警警官证',
              },
              {
                value: '士兵证',
                label: '士兵证',
              },
              {
                value: '军队离退休干部证',
                label: '军队离退休干部证',
              },
              {
                value: '残疾人证',
                label: '残疾人证',
              },
              {
                value: '残疾军人证（1-8级）',
                label: '残疾军人证（1-8级）',
              },
              {
                value: '护照',
                label: '护照',
              },
              {
                value: '港澳同胞回乡证',
                label: '港澳同胞回乡证',
              },
              {
                value: '港澳居民来往内地通行证',
                label: '港澳居民来往内地通行证',
              },
              {
                value: '外国人居留证',
                label: '外国人居留证',
              },
              {
                value: '外交官证',
                label: '外交官证',
              },
              {
                value: '香港身份证',
                label: '香港身份证',
              },
              {
                value: '台湾身份证',
                label: '台湾身份证',
              },
              {
                value: '澳门身份证',
                label: '澳门身份证',
              },
              {
                value: '外国人身份证件',
                label: '外国人身份证件',
              },
            ],
          },
          {
            label: '法人代表证件号码',
            key: 'certificatesNo',
            value: '',
            type: 'el-input',
            placeholder: '请输入法人代表证件号码',
          },
          {
            label: '法人代表证件到期日',
            key: 'certificatesEndDate',
            value: '',
            type: 'el-date-picker',
            placeholder: '请选择法人代表证件到期日',
          },
          {
            label: '注册资本(万元)',
            key: 'registeredCapital',
            value: '',
            type: 'el-input',
            placeholder: '请输入注册资本',
          },
          {
            label: '所在地区',
            key: 'region',
            value: '',
            type: 'el-cascader',
            placeholder: '请选择所在地区',
            options: cloneDeep(data),
          },
          {
            label: '成立时间',
            key: 'setUpTime',
            value: '',
            type: 'el-date-picker',
            placeholder: '请选择成立时间',
          },
          {
            label: '经营范围',
            key: 'bussScope',
            value: '',
            type: 'el-input',
            placeholder: '请输入经营范围',
            name: 'textarea',
            max: '2',
          },
          {
            label: '经济类型',
            key: 'bussType',
            value: '',
            type: 'el-select',
            placeholder: '请选择经济类型',
            options: [
              {
                label: '国有经济',
                value: '国有经济',
              },
              {
                label: '集体经济',
                value: '集体经济',
              },
              {
                label: '私营经济',
                value: '私营经济',
              },
              {
                label: '个体经济',
                value: '个体经济',
              },
              {
                label: '联营经济',
                value: '联营经济',
              },
              {
                label: '股份制',
                value: '股份制',
              },
              {
                label: '外商投资',
                value: '外商投资',
              },
              {
                label: '港澳台投资',
                value: '港澳台投资',
              },
              {
                label: '其他经济类',
                value: '其他经济类',
              },
            ],
          },
          {
            label: '注册地址',
            key: 'registeredAddress',
            value: '',
            type: 'el-input',
            placeholder: '请输入注册地址',
          },
          {
            label: '行业类型',
            key: 'industryType',
            value: '',
            type: 'el-select',
            options: [
              {
                label: '计算机',
                value: '计算机',
              },
              {
                label: '畜牧业',
                value: '畜牧业',
              },
              {
                label: '服装业',
                value: '服装业',
              },
              {
                label: '渔业',
                value: '渔业',
              },
            ],
            placeholder: '请选择行业类型',
          },
          {
            label: '联系人',
            key: 'linkMan',
            value: '',
            type: 'el-input',
            placeholder: '请输入联系人',
          },
          {
            label: '联系电话',
            key: 'linkManPhone',
            value: '',
            type: 'el-input',
            placeholder: '请输入联系电话',
          },
          {
            label: '营业执照',
            key: 'businessLicense',
            btnName: '上传营业执照',
            tips: '请上传营业执照副本扫描件，支持JPG、BMP、PNG、GIF、JPEG文档',
            value: '',
            format: '未上传',
            type: 'el-upload',
            placeholder: '请上传营业执照',
          },
        ],
        finance: [
          {
            label: '财务负责人名称',
            key: 'financialInChargeMan',
            value: '',
            type: 'el-input',
            placeholder: '请输入财务负责人名称',
          },
          {
            label: '负债(万元)',
            key: 'debt',
            value: '',
            type: 'el-input',
            placeholder: '请输入负债',
          },
          {
            label: '财务负责人手机',
            key: 'financialInChargeManPhone',
            value: '',
            input: 'el-input',
            placeholder: '请输入财务负责人手机',
          },
          {
            label: '主营业收入(万元)',
            key: 'mainBussIncome',
            value: '',
            type: 'el-input',
            placeholder: '请输入主营业收入',
          },
          {
            label: '报表年份',
            key: 'statementYear',
            value: '',
            type: 'el-date-picker',
            placeholder: '请选择报表年份',
          },
          {
            label: '净利润(万元)',
            key: 'netEarning',
            value: '',
            type: 'el-input',
            placeholder: '请输入净利润',
          },
          {
            label: '报表类型',
            key: 'statementType',
            value: '',
            type: 'el-select',
            placeholder: '请选择报表类型',
            options: [
              {
                label: '财务报表',
                value: '财务报表',
              },
              {
                label: '资产负债类报表',
                value: '资产负债类报表',
              },
              {
                label: '现金流类报表',
                value: '现金流类报表',
              },
            ],
          },
          {
            label: '是否经审计',
            key: 'hasAudited',
            value: '',
            type: 'el-radio',
            placeholder: '请选择是否经审计',
          },
          {
            label: '资产(万元)',
            key: 'capital',
            value: '',
            type: 'el-input',
            placeholder: '请输入资产',
          },
        ],
      },
    }
  },
  watch: {
    isEdit(v) {
      if (!v) {
        this.$refs.form.clearValidate()
      }
    },
    'forms.company'() {
      this.formatFile()
      this.formatRegion()
    },
  },
  methods: {
    handleDownload(v) {
      download(v)
    },
    formatRegion() {
      const v = queryValue(this.forms.company, 'region')
      if (v) {
        const index = queryKeyIndex(this.forms.company, 'region')
        const va = JSON.parse(v)
        let d = data,
          res = []
        while (va.length) {
          const cur = va.shift()
          const curData = d.find((item) => item.value === cur)
          if (curData) {
            d = curData.children
            res.push(curData.label)
          }
        }
        this.forms.company[index].format = res.join(' / ')
        this.forms.company[index].value = JSON.parse(v)
      }
    },
    formatFile() {
      const v = queryValue(this.forms.company, 'businessLicense')
      if (v) {
        queryByFileId({
          fileId: v,
        }).then((res) => {
          if(res.data){
          const index = queryKeyIndex(this.forms.company, 'businessLicense')
          const { fileName } = res.data
          this.forms.company[index].format = fileName
          }
        
        })
      }
    },
    uploadSuccess(file, item) {
      item.value = file.url
    },
    editInfo() {
      this.isEdit = true
      this.title = '我的资料/编辑'
    },
    saveForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const form = merge(
            { id: this.id },
            flat(this.forms.company),
            flat(this.forms.finance),
            {
              region: JSON.stringify(queryValue(this.forms.company, 'region')),
            }
          )

          updateUserRes(form).then((v) => {
            this.getInfo()
            if (v.code === 200) {
              this.isEdit = false
              this.$message({
                type: 'success',
                message: v.msg,
              })
            } else {
              this.$message({
                type: 'error',
                message: v.msg,
              })
            }
          })
        } else {
        }
      })
    },
    data2view(k, data) {
      this.forms[k] = cloneDeep(this.forms[k]).map((item) => {
        return {
          ...item,
          value: data[item.key],
        }
      })
    },
    getInfo() {
      getUserRes().then((v) => {
        if (typeof v.data === 'object') {
          this.data2view('company', v.data)
          this.data2view('finance', v.data)
          this.id = v.data.id
        }
      })
    },
  },
  beforeMount() {
    this.getInfo()
  },
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  padding-top: 30px;
  .ellipsis {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
::v-deep.el-cascader {
  width: 100%;
}
::v-deep.el-select {
  width: 100%;
}
::v-deep.el-date-editor {
  width: 100%;
}
</style>
